/* istanbul ignore file */
import { CreateButton, CreateButtonProps } from 'framework/ui/ui-builder';
import { useAccountUrl } from 'domain/shared/account';
import { CREATE_ACCOUNT } from '../../model';

const CreateAccountButton = (props: Partial<CreateButtonProps>) => {
  const { getCreateUrl } = useAccountUrl();

  return <CreateButton {...props} url={getCreateUrl()} permissionToCheck={CREATE_ACCOUNT} label="Create account" />;
};

export default CreateAccountButton;
